import rightArrow from "../../assets/right.svg";

export default function RightArrow() {
  return <img src={rightArrow} alt="RightArrow" />;
}
